import { createRoot } from 'react-dom/client';
import shouldRenderApp from './bootstrap/domainGuard';
import './logrocket-init';
import './index.css';
import App from './App';
import AppErrorBoundary from './components/global/AppErrorBoundary';

// StrictMode intentionally not rendered: under React 18 it double-invokes
// effects in dev, which this codebase has not been audited for yet.
if (shouldRenderApp) {
  createRoot(document.getElementById('root')).render(
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>,
  );
}
